// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1GQW9","rightAdornment":"Header_rightAdornment__1u-0V"};